<template>
  <div
    class="table-content"
    :class="{
      'cal-height': isPartialEditMode,
      'table-preview-height': !isPartialEditMode,
    }"
  >
    <div
      v-if="isPartialEditMode"
      @click="toogleSubColumn"
      style="
        display: flex;
        flex-direction: column;
        margin-left: 138px;
        width: 26px;
        cursor: pointer;
      "
    >
      <b-icon
        :icon="hasSubColumn ? 'table-row-remove' : 'table-row-plus-before'"
      >
      </b-icon>
      <b-icon icon="arrow-down"> </b-icon>
    </div>
    <div style="flex-direction: row; display: flex">
      <div
        @click="toogleSubHeader"
        v-if="isPartialEditMode"
        style="display: flex; width: 48px; cursor: pointer; margin-top: 35px"
      >
        <b-icon
          :icon="
            hasSubHeader ? 'table-column-remove' : 'table-column-plus-after'
          "
        >
        </b-icon>
        <b-icon icon="arrow-right"> </b-icon>
      </div>

      <table v-if="tableData">
        <thead :class="{ 'edit-mode': isEditFirstColumnEditable }">
          <tr>
            <th
              v-if="isPartialEditMode"
              style="text-align: center"
              class="table-cell"
            >
              <b-button
                type="is-success is-light"
                size="is-small"
                @click="toggleEditMode"
                >Edit</b-button
              >
            </th>
            <th v-else class="table-cell"></th>
            <th
              v-for="(header, index) in tableData.length > 0
                ? tableData[0].slice(1)
                : []"
              :key="`head-${index}`"
              class="table-cell"
              style="text-align: center"
              :contenteditable="isEditFirstColumnEditable"
              @input="handleHeaderInput($event, 0, index + 1)"
              @focus="onHeaderFocus($event)"
            >
              {{ header }}
            </th>
          </tr>
          <tr v-if="hasSubHeader">
            <th class="table-cell"></th>
            <th
              v-for="(header, index) in tableData.length > 0
                ? tableData[1].slice(1)
                : []"
              :key="`head-${index}`"
              class="table-cell"
              style="text-align: center"
              :contenteditable="isEditFirstColumnEditable"
              @input="handleHeaderInput($event, 1, index + 1)"
              @focus="onHeaderFocus($event)"
            >
              {{ header }}
            </th>
          </tr>
        </thead>
        <transition-group name="row-bounce" tag="tbody">
          <tr
            v-for="(row, rowIndex) in tableData.slice(hasSubHeader ? 2 : 1)"
            :key="`row-${rowIndex}`"
            :class="{
              'odd-row': rowIndex % 2 !== 0,
              'even-row': rowIndex % 2 === 0,
            }"
          >
            <template v-for="(cell, colIndex) in row">
              <template
                v-if="colIndex === 0 || (colIndex === 1 && hasSubColumn)"
              >
                <td
                  v-if="colIndex === 0"
                  class="table-cell"
                  :class="{
                    'editable-cell':
                      isEditFirstColumnEditable && colIndex === 0,
                    'editable-cell-background':
                      isEditFirstColumnEditable && colIndex === 0,
                  }"
                  :contenteditable="isCellContentEditable(colIndex)"
                  @input="handleHeaderInput($event, rowIndex + 1, colIndex)"
                  @blur="
                    onCellLeave(rowIndex + 1, colIndex, $event.target.innerText)
                  "
                  @focus="onCellFocus(rowIndex + 1, colIndex)"
                  v-html="cell"
                ></td>

                <td
                  v-if="hasSubColumn && colIndex === 1"
                  class="table-cell"
                  :class="{
                    'editable-cell':
                      isEditFirstColumnEditable && colIndex === 1,
                    'editable-cell-background':
                      isEditFirstColumnEditable && colIndex === 1,
                  }"
                  :contenteditable="isCellContentEditable(colIndex)"
                  @input="handleHeaderInput($event, rowIndex + 1, colIndex)"
                  @blur="
                    onCellLeave(rowIndex + 1, colIndex, $event.target.innerText)
                  "
                  @focus="onCellFocus(rowIndex + 1, colIndex)"
                  v-html="cell"
                ></td>
              </template>

              <td
                v-else
                class="table-cell"
                :class="{
                  'editable-cell': isEditFirstColumnEditable && colIndex === 0,
                  'editable-cell-background':
                    isEditFirstColumnEditable && colIndex === 0,
                }"
                @blur="
                  onCellLeave(rowIndex + 1, colIndex, $event.target.innerText)
                "
                @focus="onCellFocus(rowIndex, colIndex)"
                tabindex="0"
              >
                <template
                  v-if="
                    rowIndex === focusedCell.row &&
                    colIndex === focusedCell.col &&
                    isCellContentEditable(colIndex)
                  "
                >
                  <RichTextEditor
                    :value="
                      row[colIndex].value ? row[colIndex].value : row[colIndex]
                    "
                    :disabled="!isCellContentEditable(colIndex)"
                    @input="
                      (value) => handleInput(value, rowIndex + 1, colIndex)
                    "
                    :headings="[]"
                    :autoFocusOnMount="true"
                  />
                </template>
                <template v-else>
                  <DisplayRichTextEditor
                    v-if="row[colIndex] && row[colIndex].value"
                    :value="row[colIndex].value"
                  />
                  <DisplayRichTextEditor v-else :value="row[colIndex]" />
                </template>
              </td>
            </template>
          </tr>
        </transition-group>
      </table>
    </div>
  </div>
</template>

<script>
import RichTextEditor from '../../../RichTextEditor';
import DisplayRichTextEditor from '../../../RichTextEditor/DisplayRichTextEditor';

export default {
  props: {
    rows: {
      type: Number,
      required: true,
    },
    cols: {
      type: Number,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    displayType: {
      type: String,
      required: true,
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    isCSV: {
      type: Boolean,
      required: false,
      default: false,
    },
    onlyNumbers: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasSubHeaderProp: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasSubColumnProp: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  components: {
    RichTextEditor,
    DisplayRichTextEditor,
  },

  computed: {
    isInspectorMode() {
      return this.displayType === 'inspector';
    },
    isPartialEditMode() {
      return this.displayType === 'partialEdit';
    },
    user() {
      return this.$store.state.currentUser;
    },
  },
  mounted() {
    this.isEditFirstColumnEditable = false;
    this.hasSubHeader = this.hasSubHeaderProp;
    this.hasSubColumn = this.hasSubColumnProp;

    this.tableData = this.data;
    // Check if all rows have the same length, if not, pad with empty strings
    this.tableData.forEach((row) => {
      while (row.length < this.tableData[0].length) {
        row.push('');
      }
    });

    if (this.tableData.length === 0 || this.displayType === 'inspector') {
      this.createTableData();
    } else {
      this.initTempData();
    }
  },
  watch: {
    rows() {
      this.createTableData();
    },
    cols() {
      this.createTableData();
    },
    data(newData) {
      if (this.displayType === 'preview') {
        this.tableData = newData;
        this.initTempData();
      }
    },
    hasSubHeaderProp(value) {
      this.hasSubHeader = value;
    },
    hasSubColumnProp(value) {
      this.hasSubColumn = value;
    },
  },
  data() {
    return {
      isEditFirstColumnEditable: false,
      tableData: [],
      tempTableData: [],
      focusedCell: { row: null, col: null },
      hasSubHeader: false,
      hasSubColumn: false,
    };
  },
  methods: {
    toogleSubHeader() {
      this.hasSubHeader = !this.hasSubHeader;
      if (this.hasSubHeader) {
        let newRow = ['', ...Array.from({ length: this.cols }, () => '-')];
        if (this.hasSubColumn) {
          newRow = ['', '', ...Array.from({ length: this.cols }, () => '-')];
        }

        this.tempTableData.splice(1, 0, newRow);
        this.tableData.splice(1, 0, newRow);
      } else {
        this.tempTableData.splice(1, 1);
        this.tableData.splice(1, 1);
      }

      this.$emit('onHeaderControlls', {
        hasSubHeader: this.hasSubHeader,
        hasSubColumn: this.hasSubColumn,
      });
      this.normalizeTable();
    },

    toogleSubColumn() {
      this.hasSubColumn = !this.hasSubColumn;
      if (this.hasSubColumn) {
        this.tempTableData.forEach((row) => {
          row.splice(1, 0, '');
        });
        this.tableData.forEach((row) => {
          row.splice(1, 0, '');
        });
      } else {
        this.tempTableData.forEach((row) => {
          row.splice(1, 1);
        });
        this.tableData.forEach((row) => {
          row.splice(1, 1);
        });
      }
      this.$emit('onHeaderControlls', {
        hasSubHeader: this.hasSubHeader,
        hasSubColumn: this.hasSubColumn,
      });
      this.normalizeTable();
    },

    normalizeTable() {
      const maxCols = Math.max(...this.tableData.map((r) => r.length));

      this.tableData = this.tableData.map((row) => {
        const newRow = [...row];
        while (newRow.length < maxCols) newRow.push('');
        while (newRow.length > maxCols) newRow.pop();
        return newRow;
      });

      this.tempTableData = this.tableData.map((r) => [...r]);
    },

    onHeaderFocus(event) {
      // To select all text when user clicks on header cell
      const el = event.target;
      this.$nextTick(() => {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(el);
        selection.removeAllRanges();
        selection.addRange(range);
      });
    },

    onCellFocus(row, col) {
      this.focusedCell = { row, col };
    },

    getCellEl(row, col) {
      return (
        this.$el.querySelectorAll('tbody tr')[row - 1]?.children[col] || null
      );
    },

    resetFocusedCell() {
      this.focusedCell = { row: null, col: null };
    },
    onCellLeave(rowIndex, colIndex, newValue) {
      this.$emit('onCellLeave', rowIndex, colIndex, newValue);
    },
    getTempTableData() {
      return this.tempTableData;
    },
    initTempData() {
      this.tempTableData = this.tableData.map((row) => [...row]);
    },
    handleInput(value, rowIndex, colIndex) {
      const updatedValue = {
        value,
        lastUpdatedBy: this.user.fullname,
        lastModifiedAt: new Date().toISOString(),
      };
      this.tempTableData[rowIndex][colIndex] = updatedValue;
      this.tableData[rowIndex][colIndex] = updatedValue;
      this.$emit('onCellInput', rowIndex, colIndex, updatedValue);
    },

    handleHeaderInput(event, rowIndex, colIndex) {
      const value = event.target.innerText;
      this.tempTableData[rowIndex][colIndex] = value;
      this.$emit('onCellInput', rowIndex, colIndex, value);
    },

    isCellContentEditable(colIndex) {
      if (this.readOnly) {
        return false;
      }

      if (
        this.isEditFirstColumnEditable &&
        this.isPartialEditMode &&
        colIndex === 0
      ) {
        return true;
      }

      if (
        this.isEditFirstColumnEditable &&
        this.isPartialEditMode &&
        colIndex === 1 &&
        this.hasSubColumn
      ) {
        return true;
      }

      if (this.isInspectorMode && colIndex !== 0) {
        return true;
      }

      return false;
    },
    toggleEditMode() {
      this.isEditFirstColumnEditable = !this.isEditFirstColumnEditable;
      if (!this.isEditFirstColumnEditable) {
        this.tableData = this.tempTableData.map((row) => [...row]);
        this.$emit('tableDataChanged', this.tableData);
      }
    },
    createTableData() {
      let oldTableData = [...this.tableData];
      if (this.tempTableData.length > 0) {
        oldTableData = [...this.tempTableData];
      }

      if (this.isInspectorMode) {
        // Use original data structure without headers/index column
        this.tableData = oldTableData.length
          ? oldTableData
          : Array.from({ length: this.rows }, () =>
              Array.from({ length: this.cols }, () => '')
            );
      } else {
        const colsLength = this.hasSubColumn ? this.cols + 1 : this.cols;
        const rowsLength = this.hasSubHeader ? this.rows + 1 : this.rows;
        const headers = ['', ...Array.from({ length: colsLength }, () => '-')];

        this.tableData = [headers].concat(
          Array.from({ length: rowsLength }, (_, rowIndex) =>
            Array.from({ length: colsLength + 1 }, (colValue, colIndex) =>
              colIndex === 0
                ? String(this.hasSubHeader ? rowIndex : rowIndex + 1)
                : ''
            )
          )
        );

        oldTableData.forEach((row, rowIndex) => {
          row.forEach((cell, cellIndex) => {
            if (
              this.tableData[rowIndex] &&
              this.tableData[rowIndex][cellIndex] !== undefined
            ) {
              this.tableData[rowIndex][cellIndex] = cell;
            }
          });
        });
      }

      this.initTempData();
      this.$emit('tableDataChanged', this.tableData);
    },
  },
};
</script>

<style scoped lang="scss">
.subheader-controllers-container {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}
.table-content {
  overflow: scroll;
  overflow-x: hidden;
  width: 100%;

  thead {
    position: sticky;
    top: -2px;
    background: #f9fafb;
    z-index: 2;
  }
}

.table-preview-height {
  max-height: 600px;
}

// .cal-height {
//   max-height: calc(100vh - 570px);
// }

.row-bounce-enter-active {
  animation: bounceIn 0.8s ease forwards;
}

.row-bounce-leave-active {
  transition: opacity 0.1s ease;
  opacity: 0;
}

.edit-mode,
.editable-cell-background {
  background-color: #e0ffe4;
}

thead.edit-mode th {
  background-color: #e0ffe4;
}
table {
  border-collapse: collapse;
  width: 100%;
  // table-layout: fixed;
  table-layout: auto;
  border: #f5f5f5 3px solid;
}

.table-cell {
  padding: 8px;
  text-align: left;
  box-sizing: border-box;
  min-width: 70px;
  min-height: 80px;
  height: 80px;
  vertical-align: top; // keeps content at the top
}

.table-cell:not(:last-child) {
  border-right: 1px solid #ddd;
}

.table-cell:first-child {
  width: 100px;
  text-align: center;
  overflow: hidden;
}

.odd-row {
  background-color: #ffffff;
}

.even-row {
  background-color: #dddddd48;
}

@keyframes bounceIn {
  0% {
    transform: translateY(-10px);
    opacity: 0;
  }
  30% {
    transform: translateY(0);
    opacity: 1;
  }
  50% {
    transform: translateY(-10px);
  }

  80% {
    transform: translateY(-0px);
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
